(() => {
  const SELECTOR = '[data-featured-slider]';

  class Cd13FeaturedSlider {
    constructor(root) {
      if (!root || root.dataset.sliderReady === 'true') return;

      this.root = root;
      this.viewport = root.querySelector('[data-slider-viewport]');
      this.track = root.querySelector('.cd13-featured-slider__track');
      this.previousButton = root.querySelector('[data-slider-prev]');
      this.nextButton = root.querySelector('[data-slider-next]');
      this.frame = null;

      if (!this.viewport || !this.track || !this.previousButton || !this.nextButton) return;

      this.root.dataset.sliderReady = 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.previousButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.viewport.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      window.addEventListener('resize', () => this.requestUpdate(), { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.track);
      }

      this.updateControls();
    }

    getStep() {
      const slide = this.track.querySelector('.cd13-featured-slider__slide');
      if (!slide) return this.viewport.clientWidth;

      const styles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    move(direction) {
      this.viewport.scrollBy({
        left: direction * this.getStep(),
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    requestUpdate() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        this.updateControls();
      });
    }

    updateControls() {
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const current = Math.min(maxScroll, Math.max(0, this.viewport.scrollLeft));
      const tolerance = 3;

      this.previousButton.disabled = current <= tolerance;
      this.nextButton.disabled = current >= maxScroll - tolerance;
    }
  }

  const initialize = (scope = document) => {
    const roots = scope.matches?.(SELECTOR) ? [scope] : scope.querySelectorAll(SELECTOR);
    roots.forEach((root) => new Cd13FeaturedSlider(root));
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
